import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from "react";
import { translate } from "./translations";
const STORAGE_KEY = "itr-agent-lang";
const LanguageContext = createContext(null);
function readInitialLang() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw === "en" || raw === "ru")
            return raw;
    }
    catch {
        /* ignore */
    }
    return "ru";
}
export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(readInitialLang);
    const setLang = useCallback((next) => {
        setLangState(next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        }
        catch {
            /* ignore */
        }
    }, []);
    useLayoutEffect(() => {
        document.documentElement.lang = lang === "en" ? "en" : "ru";
    }, [lang]);
    const t = useCallback((key, params) => translate(lang, key, params), [lang]);
    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
    return _jsx(LanguageContext.Provider, { value: value, children: children });
};
export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx)
        throw new Error("useLanguage must be used inside LanguageProvider");
    return ctx;
};
